
import Header from '../sections/Header';
import Footer from '../sections/Footer';
import Contact from '../sections/Contact';
export default function ContactPage(){
    return (
      <>
        <Header/>
        <Contact/>
        <Footer/>
        
        </>
    )
  
}